import React, { useRef, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getParentInfoById, getParentIdByRefId, findOtherProjects } from "../../utils/tree";
import { changeParentOfTask } from "../../redux/actions/TodoManipulation/changeParentAction";

const MoveTaskToNewParent = (props) => {
    const { onClose, taskId, parentRef, addItemMode, handleNewParentAdded } = props;
    const ref = useRef();
    const dispatch = useDispatch();
    const projects = useSelector((state) => state.taskList.data);
    const [otherProjects, setOtherProjects] = useState([]);
    const [pressedButtonIndex, setPressedButtonIndex] = useState(-1);
    const [disableButtons, setDisableButtons] = useState(true);

    const handleClose = () => {
        onClose();
    };

    const handleMove = () => {

        if (pressedButtonIndex === -1) return;

        const newParent = getParentInfoById(projects, pressedButtonIndex);
        if (addItemMode) {
            handleNewParentAdded(newParent.id);
        }
        else {
            const changeParentJson = {
                id: taskId,
                ParentId: newParent.id,
                SiblingPosition: (newParent.children && newParent.children.length > 0) ? newParent.children.length - 1 : 0,
            };

            dispatch(changeParentOfTask(changeParentJson));
        }
        

        onClose();
    };

    const handleMoveToProjectClick = (index) => {
        setPressedButtonIndex(index);

        if (index === -1) {
            setDisableButtons(true);
        } else {
            setDisableButtons(false);
        }
    };

    useEffect(() => {
        const parentId = getParentIdByRefId(projects, parentRef)
        const otherProjects = findOtherProjects(projects, parentId);
        setOtherProjects(otherProjects);

    }, []);

    return (

        <div className="gt-move-to__window"
            style={{ height: '100dvh' }} >
                <div className="gt-move-to__header">
                    <h3 id="moveTo">Move to</h3>
                </div>
                <ul className="gt-move-to__list">
                {otherProjects.map((item) => (
                    item.id !== taskId && ( 
                        <li key={item.id}>
                            <div className="gt-move-to__color" style={{ background: item.color?.hexString || "#80C3E9" }} />
                            <button
                                onClick={() => handleMoveToProjectClick(item.id)}
                                aria-pressed={item.id === pressedButtonIndex ? 'true' : 'false'}>
                                <svg xmlns="http://www.w3.org/2000/svg">
                                    <use href="#globaltasks-svg-folder"></use>
                                </svg>
                                {item.title}
                            </button>
                        </li>
                    )
                ))}
                </ul>
                <div className="gt-move-to__footer">
                    <button type="button" className="gw-button gw-button--s1 gw-button--secondary"
                        onClick={() => { handleClose() }}
                    >Cancel</button>
                    <button type="button" className="gw-button gw-button--s1 gw-button--primary"
                        onClick={() => { handleMove() }} 
                        disabled={disableButtons}
                    >Move</button>
                </div>
            </div>
    );
};

export default MoveTaskToNewParent;